<template>
  <div>
    <a-card class="customer-filter" size="small">
      <a-page-header title="工单信息">
        <a-form-model :form="filterForm" :label-col="{ span: 6 }" :model="filterForm" class="search-form">
          <a-row>
            <a-col :span="6">
              <a-form-model-item label="标题">
                <a-input v-model="filterForm.title" allow-clear placeholder="工单标题" class="form-model-item" @change="onSearch" />
              </a-form-model-item>
            </a-col>
            <a-col :span="6">
              <a-form-model-item label="问题类型">
                <a-tree-select v-model="filterForm.tags" show-search multiple :filter-tree-node="filterModule" :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }" style="width: 100%" :tree-data="showTagList" @change="onSearch" />
              </a-form-model-item>
            </a-col>
            <a-col :span="6">
              <a-form-model-item label="状态">
                <a-select v-model="filterForm.status" mode="multiple" allow-clear placeholder="状态" @change="onSearch">
                  <a-select-option v-for="(item, index) in ticketStatus" :key="index" :value="item.value">
                    <a-badge :status="item.status" :color="item.color" :text="item.label" />
                  </a-select-option>
                </a-select>
              </a-form-model-item>
            </a-col>
            <a-col :span="6">
              <a-form-model-item label="业务域">
                <a-select v-model="filterForm.team" mode="multiple" allow-clear placeholder="问题类型" @change="onSearch">
                  <a-select-option v-for="(item, index) in ticketDomain" :key="index" :value="item.value">
                    <a-badge :status="item.team" :color="item.color" :text="item.label" />
                  </a-select-option>
                </a-select>
              </a-form-model-item>
            </a-col>
            <a-col :span="6">
              <a-form-model-item v-show="expand" label="工单排查人">
                <a-select v-model="filterForm.handler" mode="multiple" allow-clear placeholder="处理人" show-search :filter-option="utils.filterOption" @change="onSearch">
                  <a-select-option v-for="(user, index) in userData" :key="index" :value="user.fs_user_id">{{ user.nickname }} </a-select-option>
                </a-select>
              </a-form-model-item>
            </a-col>
            <a-col :span="6">
              <a-form-model-item label="渠道工单id">
                <a-input v-model="filterForm.qiyuTicketId" allow-clear placeholder="渠道工单id" class="form-model-item" @change="onSearch" />
              </a-form-model-item>
            </a-col>
            <a-col :span="6">
              <a-form-model-item v-show="expand" label="与我相关">
                <a-radio-group v-model="filterForm.about" button-style="solid" @change="onSearch">
                  <a-radio-button value="all"> 全部 </a-radio-button>
                  <a-radio-button value="about"> 与我相关 </a-radio-button>
                </a-radio-group>
              </a-form-model-item>
            </a-col>
            <a-col :span="6">
              <a-form-model-item v-show="expand" label="创建时间">
                <a-range-picker v-model="timeList" @change="onSearch" />
              </a-form-model-item>
            </a-col>
          </a-row>
          <a-row>
            <a-col :span="6" style="float: right; text-align: right">
              <a-button type="primary" @click="getProblemList">查询</a-button>
              <!-- <a-button type="primary" @click="doTicketExplore">导出</a-button> -->
              <a-button :style="{ margin: '0 8px' }" @click="reset">重置</a-button>
            </a-col>
          </a-row>
        </a-form-model>
      </a-page-header>
    </a-card>
    <a-card title="" class="filter-data">
      <a-tabs @change="handleTabChange">
        <a-tab-pane key="1" tab="工单列表">
          <ticket-list :ticket-list="tableData" :pagination="pagination" :columns="ticketColumns" :ticket-tag-list="problemTags" @callback="handleTableChange" />
        </a-tab-pane>
      </a-tabs>
    </a-card>
    <problem-modal :is-show="modalVisible" :problem-id="problemId" @close="close" />
    <fault-drawer :display="faultVisible" :source-id="sourceId" @close="close" />
  </div>
</template>

<script>
import moment from 'moment';
import { userList } from '@/api/system/auth';
import { projectList } from '@/api/project/project';
import { queryTickets } from '@/api/event/problem';
import { ticketTags } from '@/api/event/problem';
import FaultDrawer from '@/pages/event/components/FaultDrawer';
import ProblemModal from '@/pages/event/components/ProblemModal';
import TicketList from '@/pages/event/components/TicketList';
import { ticketStatus, ticketDomain, ticketLevel, ticektTag, qiyuTicketStatus, ticketColumns } from '@/utils/dictionary';
export default {
  components: { ProblemModal, FaultDrawer, TicketList },
  data() {
    return {
      loading: false,
      expand: true,
      ticketColumns,
      sourceId: null,
      problemId: null,
      timeList: [],
      ticketDomain,
      ticketLevel,
      ticketStatus,
      ticektTag,
      qiyuTicketStatus,
      problemTags: [],
      showTagList: [],
      userData: [],
      projects: [],
      filterForm: {
        pageSize: 20,
        pageNumber: 1
      },
      pagination: {
        size: 'large',
        total: 0,
        pageSize: 20, // 每页中显示10条数据
        showSizeChanger: true,
        pageSizeOptions: ['10', '20', '50', '100'], // 每页中显示的数据
        showTotal: total => `共 ${total} 条` // 分页中显示总的数据
      },
      faultVisible: false,
      modalVisible: false,
      tableData: []
    };
  },
  computed: {
    project() {
      return projects => {
        const temp = projects.map(p => {
          return p.name;
        });
        return temp.join('; ');
      };
    },
    getUser() {
      return user => {
        return user === null ? '--' : user.nickname;
      };
    }
  },
  mounted() {
    this.getProblemList();
    this.getProjectList();
    this.getUserList();
    this.getTicketTags();
  },
  methods: {
    // 获取用户列表
    getUserList() {
      userList({}).then(res => {
        this.userData = res.data.users.filter(user => user.isDeleted !== 1 && user.fs_user_id !== '' && user.fs_user_id !== null);
      });
    },
    getTicketTags() {
      ticketTags({}).then(res => {
        const problemTags = res.data.items;
        this.problemTags = problemTags;
        this.showTagList = this.removeDisabledFromTagList(problemTags);
      });
    },
    removeDisabledFromTagList(tagList) {
      for (let i = 0; i < tagList.length; i++) {
        tagList[i].disabled = false;
      }
      return tagList;
    },

    filterModule(searchValue, treeNode) {
      return treeNode.data.props.title.includes(searchValue);
    },
    getUserById(user_id) {
      const user = this.userData.find(item => item.fs_user_id === user_id);
      return user.nickname;
    },
    // 获取项目列表
    getProjectList() {
      projectList({}).then(res => {
        this.projects = res.data.projects;
      });
    },
    handleTabChange(key) {
      if (key === '2') {
        this.queryOverTimeTicket();
      }
      if (key === '1') {
        this.getProblemList();
      }
    },
    handleTableChange(filterForm) {
      this.filterForm.pageSize = filterForm.pageSize;
      this.filterForm.pageNumber = filterForm.pageNumber;
      this.getProblemList();
    },
    // 查看故障详情
    onViewFault(record) {
      this.$router.push({
        name: 'page:event:ticket:detail',
        query: { ticketId: record.id }
      });
    },

    onToFault(record) {
      this.sourceId = record.id;
      this.faultVisible = true;
    },

    toggle() {
      this.expand = !this.expand;
    },

    // 获取问题列表
    getProblemList() {
      this.loading = true;
      this.filterForm.isOverTime = 2;
      if (this.timeList.length > 0) {
        this.filterForm.startTime = moment(this.timeList[0]).format('YYYY-MM-DD');
        this.filterForm.endTime = moment(this.timeList[1]).format('YYYY-MM-DD');
      } else {
        this.filterForm.startTime = null;
        this.filterForm.endTime = null;
      }
      queryTickets(this.filterForm)
        .then(res => {
          this.tableData = res.data.ticketList;
          this.pagination.total = res.data.total;
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },

    queryOverTimeTicket() {
      this.loading = true;
      this.filterForm.isOverTime = 1;
      queryTickets(this.filterForm)
        .then(res => {
          this.tableData = res.data.ticketList;
          this.pagination.total = res.data.total;
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },

    reset() {
      this.filterForm = {
        pageSize: this.pagination.pageSize,
        pageNumber: 1
      };
      this.getProblemList();
    },

    onSearch() {
      this.filterForm.pageNumber = 1;
      this.getProblemList();
    },

    // 关闭弹窗
    close(type) {
      this.modalVisible = false;
      this.faultVisible = false;
      if (type === 'submit') {
        this.getProblemList();
      }
    }
  }
};
</script>

<style lang="less" scoped>
/deep/ .customer-filter {
  .ant-page-header {
    padding: 0;
  }
  margin-bottom: 16px;
  .ant-form-item {
    margin-bottom: 8px;
    display: flex;
    .ant-form-item-control-wrapper {
      flex: 1;
    }
  }
  .filter-right {
    float: right;
    text-align: right;
  }
}
.custom-link {
  color: rgba(0, 0, 0, 0.65);
}
.custom-link:hover {
  color: #1890ff;
}
/deep/.is-fault.ant-tag {
  margin-right: 0;
}
</style>
